/*
 * boks-lazy-video — videos <video data-boks-lazy-video> chargees seulement a l'approche de l'ecran.
 *
 * Perf (lot 1 PageSpeed, 11-2026) : une <video autoplay> se telecharge des l'ouverture de la page,
 * meme loin sous la ligne de flottaison (PageSpeed : MP4 1080p de 1,2 Mo en concurrence avec la
 * photo produit). Ici, rien n'est charge (ni video ni image d'attente) avant que la video soit a
 * moins de 300 px de l'ecran ; les videos en lecture auto jouent quand elles sont visibles et se
 * mettent en pause hors ecran.
 *
 * Attributs lus sur <video> :
 *   data-src-desktop / data-src-mobile  URL MP4 (>= 750 px de large = desktop)
 *   data-poster                         image d'attente (optionnelle)
 *   data-autoplay                       lecture auto muette (sinon : controles, lecture au clic)
 *
 * Utilise par sections/boks-feature-split.liquid. Script charge une fois par section : le garde
 * window.BoksLazyVideo evite la double initialisation. Theme editor : re-scan sur shopify:section:load.
 */
(function () {
  if (window.BoksLazyVideo) {
    window.BoksLazyVideo.init();
    return;
  }

  var desktop = window.matchMedia('(min-width: 750px)');

  function source(video) {
    return (desktop.matches ? video.dataset.srcDesktop : video.dataset.srcMobile) || video.dataset.srcDesktop;
  }

  function prime(video) {
    if (video.dataset.boksLoaded) return;
    video.dataset.boksLoaded = '1';
    if (video.dataset.poster) video.poster = video.dataset.poster;
    video.src = source(video);
  }

  function play(video) {
    if (!video.hasAttribute('data-autoplay')) return;
    video.muted = true;
    var p = video.play();
    if (p && typeof p.catch === 'function') p.catch(function () {});
  }

  var observer =
    'IntersectionObserver' in window
      ? new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              var video = entry.target;
              if (entry.isIntersecting) {
                prime(video);
                play(video);
              } else if (video.hasAttribute('data-autoplay') && !video.paused) {
                video.pause();
              }
            });
          },
          { rootMargin: '300px 0px' }
        )
      : null;

  function init() {
    document.querySelectorAll('video[data-boks-lazy-video]').forEach(function (video) {
      if (video.dataset.boksObserved) return;
      video.dataset.boksObserved = '1';
      if (observer) {
        observer.observe(video);
      } else {
        prime(video);
        play(video);
      }
    });
  }

  window.BoksLazyVideo = { init: init };
  init();
  document.addEventListener('shopify:section:load', init);
})();
